export type SpanEditResult = {
  text: string;
  applied: boolean;
};

/** Preview-only rewrite matching backend `apply_text_edit` (literal, case-sensitive). */
export const applySpanEdit = (
  text: string,
  oldString: string,
  newString: string,
  replaceAll: boolean
): SpanEditResult => {
  if (!oldString || oldString === newString) return { text, applied: false };
  const count = text.split(oldString).length - 1;
  if (count === 0) return { text, applied: false };
  if (count > 1 && !replaceAll) return { text, applied: false };
  return { text: text.split(oldString).join(newString), applied: true };
};
